import {
  BadgeSize,
  ColorMap,
  SizeDefinition,
  Timezone,
} from './interfaces/common.interface';
import { MatDialogConfig } from '@angular/material/dialog';
import { MatDateFormats } from '@angular/material/core';

export const CHART_COLORS = [
  '#24C9A7',
  '#0059FF',
  '#FFAB00',
  '#B237BC',
  '#FF0000',
  '#7070FF',
  '#FD6191',
  '#1D2258',
  '#2F93F5',
  '#40E7F2',
  '#F5912F',
];

export const avatarColors = [
  'violet',
  'purple',
  'pink',
  'orange',
  'indigo',
  'sky-blue',
  'green',
  'coral',
];

export const pageSizeOptions = [10, 20, 40, 50, 100];
export const defaultPageSize = pageSizeOptions[1];

export const apiDateFormat = 'YYYY-MM-DD';
export const apiDateTimeFormat = 'YYYY-MM-DD HH:mm:ss';

export const defaultDateFormat = 'DD MMM YYYY LT';
export const serverTimezone = 'UTC';
export const defaultLuxonDateFormat = 'dd MMM yyyy hh:mm a';
export const apiLuxonDateFormat = 'yyyy-MM-dd HH:mm:ss';
export const luxonDateFormat = 'MM/dd/yy';
export const luxonTimeFormat = 'HHmm';
export const apiLuxonDateFormatNoTime = 'yyyy-MM-dd';
export const apiLuxonTimeFormat = 'HH:mm:ss';
export const luxonDateTimeFormat = `${luxonDateFormat} ${luxonTimeFormat}`;

export const ngxMatDateFormats: MatDateFormats = {
  parse: {
    dateInput: 'MM/DD/YY HHmm',
  },
  display: {
    dateInput: 'MM/DD/YY HHmm',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export const defaultMatDialogConfig: MatDialogConfig = {
  width: '420px',
  panelClass: 'twc-dialog',
  autoFocus: 'first-tabbable',
  delayFocusTrap: true,
  hasBackdrop: true,
  position: {
    top: '80px',
  },
};

export const timezones: Timezone[] = [
  {
    identifier: 'Pacific/Marquesas',
    utc_offset: '(UTC-9:30)',
    combined_info: '(UTC-9:30) Pacific/Marquesas',
  },
  {
    identifier: 'Pacific/Gambier',
    utc_offset: '(UTC-9)',
    combined_info: '(UTC-9) Pacific/Gambier',
  },
  {
    identifier: 'America/Yakutat',
    utc_offset: '(UTC-9)',
    combined_info: '(UTC-9) America/Yakutat',
  },
  {
    identifier: 'America/Sitka',
    utc_offset: '(UTC-9)',
    combined_info: '(UTC-9) America/Sitka',
  },
  {
    identifier: 'America/Nome',
    utc_offset: '(UTC-9)',
    combined_info: '(UTC-9) America/Nome',
  },
  {
    identifier: 'America/Metlakatla',
    utc_offset: '(UTC-9)',
    combined_info: '(UTC-9) America/Metlakatla',
  },
  {
    identifier: 'America/Juneau',
    utc_offset: '(UTC-9)',
    combined_info: '(UTC-9) America/Juneau',
  },
  {
    identifier: 'America/Anchorage',
    utc_offset: '(UTC-9)',
    combined_info: '(UTC-9) America/Anchorage',
  },
  {
    identifier: 'Pacific/Pitcairn',
    utc_offset: '(UTC-8)',
    combined_info: '(UTC-8) Pacific/Pitcairn',
  },
  {
    identifier: 'America/Vancouver',
    utc_offset: '(UTC-8)',
    combined_info: '(UTC-8) America/Vancouver',
  },
  {
    identifier: 'America/Tijuana',
    utc_offset: '(UTC-8)',
    combined_info: '(UTC-8) America/Tijuana',
  },
  {
    identifier: 'America/Los_Angeles',
    utc_offset: '(UTC-8)',
    combined_info: '(UTC-8) America/Los_Angeles',
  },
  {
    identifier: 'America/Yellowknife',
    utc_offset: '(UTC-7)',
    combined_info: '(UTC-7) America/Yellowknife',
  },
  {
    identifier: 'America/Whitehorse',
    utc_offset: '(UTC-7)',
    combined_info: '(UTC-7) America/Whitehorse',
  },
  {
    identifier: 'America/Phoenix',
    utc_offset: '(UTC-7)',
    combined_info: '(UTC-7) America/Phoenix',
  },
  {
    identifier: 'America/Ojinaga',
    utc_offset: '(UTC-7)',
    combined_info: '(UTC-7) America/Ojinaga',
  },
  {
    identifier: 'America/Mazatlan',
    utc_offset: '(UTC-7)',
    combined_info: '(UTC-7) America/Mazatlan',
  },
  {
    identifier: 'America/Inuvik',
    utc_offset: '(UTC-7)',
    combined_info: '(UTC-7) America/Inuvik',
  },
  {
    identifier: 'America/Hermosillo',
    utc_offset: '(UTC-7)',
    combined_info: '(UTC-7) America/Hermosillo',
  },
  {
    identifier: 'America/Fort_Nelson',
    utc_offset: '(UTC-7)',
    combined_info: '(UTC-7) America/Fort_Nelson',
  },
  {
    identifier: 'America/Edmonton',
    utc_offset: '(UTC-7)',
    combined_info: '(UTC-7) America/Edmonton',
  },
  {
    identifier: 'America/Denver',
    utc_offset: '(UTC-7)',
    combined_info: '(UTC-7) America/Denver',
  },
  {
    identifier: 'America/Dawson_Creek',
    utc_offset: '(UTC-7)',
    combined_info: '(UTC-7) America/Dawson_Creek',
  },
  {
    identifier: 'America/Dawson',
    utc_offset: '(UTC-7)',
    combined_info: '(UTC-7) America/Dawson',
  },
  {
    identifier: 'America/Creston',
    utc_offset: '(UTC-7)',
    combined_info: '(UTC-7) America/Creston',
  },
  {
    identifier: 'America/Chihuahua',
    utc_offset: '(UTC-7)',
    combined_info: '(UTC-7) America/Chihuahua',
  },
  {
    identifier: 'America/Cambridge_Bay',
    utc_offset: '(UTC-7)',
    combined_info: '(UTC-7) America/Cambridge_Bay',
  },
  {
    identifier: 'America/Boise',
    utc_offset: '(UTC-7)',
    combined_info: '(UTC-7) America/Boise',
  },
  {
    identifier: 'Pacific/Galapagos',
    utc_offset: '(UTC-6)',
    combined_info: '(UTC-6) Pacific/Galapagos',
  },
  {
    identifier: 'Pacific/Easter',
    utc_offset: '(UTC-6)',
    combined_info: '(UTC-6) Pacific/Easter',
  },
  {
    identifier: 'America/Winnipeg',
    utc_offset: '(UTC-6)',
    combined_info: '(UTC-6) America/Winnipeg',
  },
  {
    identifier: 'America/Tegucigalpa',
    utc_offset: '(UTC-6)',
    combined_info: '(UTC-6) America/Tegucigalpa',
  },
  {
    identifier: 'America/Swift_Current',
    utc_offset: '(UTC-6)',
    combined_info: '(UTC-6) America/Swift_Current',
  },
  {
    identifier: 'America/Resolute',
    utc_offset: '(UTC-6)',
    combined_info: '(UTC-6) America/Resolute',
  },
  {
    identifier: 'America/Regina',
    utc_offset: '(UTC-6)',
    combined_info: '(UTC-6) America/Regina',
  },
  {
    identifier: 'America/Rankin_Inlet',
    utc_offset: '(UTC-6)',
    combined_info: '(UTC-6) America/Rankin_Inlet',
  },
  {
    identifier: 'America/Rainy_River',
    utc_offset: '(UTC-6)',
    combined_info: '(UTC-6) America/Rainy_River',
  },
  {
    identifier: 'America/North_Dakota/New_Salem',
    utc_offset: '(UTC-6)',
    combined_info: '(UTC-6) America/North_Dakota/New_Salem',
  },
  {
    identifier: 'America/North_Dakota/Center',
    utc_offset: '(UTC-6)',
    combined_info: '(UTC-6) America/North_Dakota/Center',
  },
  {
    identifier: 'America/North_Dakota/Beulah',
    utc_offset: '(UTC-6)',
    combined_info: '(UTC-6) America/North_Dakota/Beulah',
  },
  {
    identifier: 'America/Monterrey',
    utc_offset: '(UTC-6)',
    combined_info: '(UTC-6) America/Monterrey',
  },
  {
    identifier: 'America/Mexico_City',
    utc_offset: '(UTC-6)',
    combined_info: '(UTC-6) America/Mexico_City',
  },
  {
    identifier: 'America/Merida',
    utc_offset: '(UTC-6)',
    combined_info: '(UTC-6) America/Merida',
  },
  {
    identifier: 'America/Menominee',
    utc_offset: '(UTC-6)',
    combined_info: '(UTC-6) America/Menominee',
  },
  {
    identifier: 'America/Matamoros',
    utc_offset: '(UTC-6)',
    combined_info: '(UTC-6) America/Matamoros',
  },
  {
    identifier: 'America/Managua',
    utc_offset: '(UTC-6)',
    combined_info: '(UTC-6) America/Managua',
  },
  {
    identifier: 'America/Indiana/Tell_City',
    utc_offset: '(UTC-6)',
    combined_info: '(UTC-6) America/Indiana/Tell_City',
  },
  {
    identifier: 'America/Indiana/Knox',
    utc_offset: '(UTC-6)',
    combined_info: '(UTC-6) America/Indiana/Knox',
  },
  {
    identifier: 'America/Guatemala',
    utc_offset: '(UTC-6)',
    combined_info: '(UTC-6) America/Guatemala',
  },
  {
    identifier: 'America/El_Salvador',
    utc_offset: '(UTC-6)',
    combined_info: '(UTC-6) America/El_Salvador',
  },
  {
    identifier: 'America/Costa_Rica',
    utc_offset: '(UTC-6)',
    combined_info: '(UTC-6) America/Costa_Rica',
  },
  {
    identifier: 'America/Chicago',
    utc_offset: '(UTC-6)',
    combined_info: '(UTC-6) America/Chicago',
  },
  {
    identifier: 'America/Belize',
    utc_offset: '(UTC-6)',
    combined_info: '(UTC-6) America/Belize',
  },
  {
    identifier: 'America/Bahia_Banderas',
    utc_offset: '(UTC-6)',
    combined_info: '(UTC-6) America/Bahia_Banderas',
  },
  {
    identifier: 'America/Toronto',
    utc_offset: '(UTC-5)',
    combined_info: '(UTC-5) America/Toronto',
  },
  {
    identifier: 'America/Thunder_Bay',
    utc_offset: '(UTC-5)',
    combined_info: '(UTC-5) America/Thunder_Bay',
  },
  {
    identifier: 'America/Rio_Branco',
    utc_offset: '(UTC-5)',
    combined_info: '(UTC-5) America/Rio_Branco',
  },
  {
    identifier: 'America/Port-au-Prince',
    utc_offset: '(UTC-5)',
    combined_info: '(UTC-5) America/Port-au-Prince',
  },
  {
    identifier: 'America/Pangnirtung',
    utc_offset: '(UTC-5)',
    combined_info: '(UTC-5) America/Pangnirtung',
  },
  {
    identifier: 'America/Panama',
    utc_offset: '(UTC-5)',
    combined_info: '(UTC-5) America/Panama',
  },
  {
    identifier: 'America/Nipigon',
    utc_offset: '(UTC-5)',
    combined_info: '(UTC-5) America/Nipigon',
  },
  {
    identifier: 'America/New_York',
    utc_offset: '(UTC-5)',
    combined_info: '(UTC-5) America/New_York',
  },
  {
    identifier: 'America/Nassau',
    utc_offset: '(UTC-5)',
    combined_info: '(UTC-5) America/Nassau',
  },
  {
    identifier: 'America/Lima',
    utc_offset: '(UTC-5)',
    combined_info: '(UTC-5) America/Lima',
  },
  {
    identifier: 'America/Kentucky/Monticello',
    utc_offset: '(UTC-5)',
    combined_info: '(UTC-5) America/Kentucky/Monticello',
  },
  {
    identifier: 'America/Kentucky/Louisville',
    utc_offset: '(UTC-5)',
    combined_info: '(UTC-5) America/Kentucky/Louisville',
  },
  {
    identifier: 'America/Jamaica',
    utc_offset: '(UTC-5)',
    combined_info: '(UTC-5) America/Jamaica',
  },
  {
    identifier: 'America/Iqaluit',
    utc_offset: '(UTC-5)',
    combined_info: '(UTC-5) America/Iqaluit',
  },
  {
    identifier: 'America/Indiana/Winamac',
    utc_offset: '(UTC-5)',
    combined_info: '(UTC-5) America/Indiana/Winamac',
  },
  {
    identifier: 'America/Indiana/Vincennes',
    utc_offset: '(UTC-5)',
    combined_info: '(UTC-5) America/Indiana/Vincennes',
  },
  {
    identifier: 'America/Indiana/Vevay',
    utc_offset: '(UTC-5)',
    combined_info: '(UTC-5) America/Indiana/Vevay',
  },
  {
    identifier: 'America/Indiana/Petersburg',
    utc_offset: '(UTC-5)',
    combined_info: '(UTC-5) America/Indiana/Petersburg',
  },
  {
    identifier: 'America/Indiana/Marengo',
    utc_offset: '(UTC-5)',
    combined_info: '(UTC-5) America/Indiana/Marengo',
  },
  {
    identifier: 'America/Indiana/Indianapolis',
    utc_offset: '(UTC-5)',
    combined_info: '(UTC-5) America/Indiana/Indianapolis',
  },
  {
    identifier: 'America/Havana',
    utc_offset: '(UTC-5)',
    combined_info: '(UTC-5) America/Havana',
  },
  {
    identifier: 'America/Guayaquil',
    utc_offset: '(UTC-5)',
    combined_info: '(UTC-5) America/Guayaquil',
  },
  {
    identifier: 'America/Grand_Turk',
    utc_offset: '(UTC-5)',
    combined_info: '(UTC-5) America/Grand_Turk',
  },
  {
    identifier: 'America/Eirunepe',
    utc_offset: '(UTC-5)',
    combined_info: '(UTC-5) America/Eirunepe',
  },
  {
    identifier: 'America/Detroit',
    utc_offset: '(UTC-5)',
    combined_info: '(UTC-5) America/Detroit',
  },
  {
    identifier: 'America/Cayman',
    utc_offset: '(UTC-5)',
    combined_info: '(UTC-5) America/Cayman',
  },
  {
    identifier: 'America/Cancun',
    utc_offset: '(UTC-5)',
    combined_info: '(UTC-5) America/Cancun',
  },
  {
    identifier: 'America/Bogota',
    utc_offset: '(UTC-5)',
    combined_info: '(UTC-5) America/Bogota',
  },
  {
    identifier: 'America/Atikokan',
    utc_offset: '(UTC-5)',
    combined_info: '(UTC-5) America/Atikokan',
  },
  {
    identifier: 'Atlantic/Bermuda',
    utc_offset: '(UTC-4)',
    combined_info: '(UTC-4) Atlantic/Bermuda',
  },
  {
    identifier: 'America/Tortola',
    utc_offset: '(UTC-4)',
    combined_info: '(UTC-4) America/Tortola',
  },
  {
    identifier: 'America/Thule',
    utc_offset: '(UTC-4)',
    combined_info: '(UTC-4) America/Thule',
  },
  {
    identifier: 'America/St_Vincent',
    utc_offset: '(UTC-4)',
    combined_info: '(UTC-4) America/St_Vincent',
  },
  {
    identifier: 'America/St_Thomas',
    utc_offset: '(UTC-4)',
    combined_info: '(UTC-4) America/St_Thomas',
  },
  {
    identifier: 'America/St_Lucia',
    utc_offset: '(UTC-4)',
    combined_info: '(UTC-4) America/St_Lucia',
  },
  {
    identifier: 'America/St_Kitts',
    utc_offset: '(UTC-4)',
    combined_info: '(UTC-4) America/St_Kitts',
  },
  {
    identifier: 'America/St_Barthelemy',
    utc_offset: '(UTC-4)',
    combined_info: '(UTC-4) America/St_Barthelemy',
  },
  {
    identifier: 'America/Santo_Domingo',
    utc_offset: '(UTC-4)',
    combined_info: '(UTC-4) America/Santo_Domingo',
  },
  {
    identifier: 'America/Santiago',
    utc_offset: '(UTC-4)',
    combined_info: '(UTC-4) America/Santiago',
  },
  {
    identifier: 'America/Puerto_Rico',
    utc_offset: '(UTC-4)',
    combined_info: '(UTC-4) America/Puerto_Rico',
  },
  {
    identifier: 'America/Porto_Velho',
    utc_offset: '(UTC-4)',
    combined_info: '(UTC-4) America/Porto_Velho',
  },
  {
    identifier: 'America/Port_of_Spain',
    utc_offset: '(UTC-4)',
    combined_info: '(UTC-4) America/Port_of_Spain',
  },
  {
    identifier: 'America/Montserrat',
    utc_offset: '(UTC-4)',
    combined_info: '(UTC-4) America/Montserrat',
  },
  {
    identifier: 'America/Moncton',
    utc_offset: '(UTC-4)',
    combined_info: '(UTC-4) America/Moncton',
  },
  {
    identifier: 'America/Martinique',
    utc_offset: '(UTC-4)',
    combined_info: '(UTC-4) America/Martinique',
  },
  {
    identifier: 'America/Marigot',
    utc_offset: '(UTC-4)',
    combined_info: '(UTC-4) America/Marigot',
  },
  {
    identifier: 'America/Manaus',
    utc_offset: '(UTC-4)',
    combined_info: '(UTC-4) America/Manaus',
  },
  {
    identifier: 'America/Lower_Princes',
    utc_offset: '(UTC-4)',
    combined_info: '(UTC-4) America/Lower_Princes',
  },
  {
    identifier: 'America/La_Paz',
    utc_offset: '(UTC-4)',
    combined_info: '(UTC-4) America/La_Paz',
  },
  {
    identifier: 'America/Kralendijk',
    utc_offset: '(UTC-4)',
    combined_info: '(UTC-4) America/Kralendijk',
  },
  {
    identifier: 'America/Halifax',
    utc_offset: '(UTC-4)',
    combined_info: '(UTC-4) America/Halifax',
  },
  {
    identifier: 'America/Guyana',
    utc_offset: '(UTC-4)',
    combined_info: '(UTC-4) America/Guyana',
  },
  {
    identifier: 'America/Guadeloupe',
    utc_offset: '(UTC-4)',
    combined_info: '(UTC-4) America/Guadeloupe',
  },
  {
    identifier: 'America/Grenada',
    utc_offset: '(UTC-4)',
    combined_info: '(UTC-4) America/Grenada',
  },
  {
    identifier: 'America/Goose_Bay',
    utc_offset: '(UTC-4)',
    combined_info: '(UTC-4) America/Goose_Bay',
  },
  {
    identifier: 'America/Glace_Bay',
    utc_offset: '(UTC-4)',
    combined_info: '(UTC-4) America/Glace_Bay',
  },
  {
    identifier: 'America/Dominica',
    utc_offset: '(UTC-4)',
    combined_info: '(UTC-4) America/Dominica',
  },
  {
    identifier: 'America/Curacao',
    utc_offset: '(UTC-4)',
    combined_info: '(UTC-4) America/Curacao',
  },
  {
    identifier: 'America/Cuiaba',
    utc_offset: '(UTC-4)',
    combined_info: '(UTC-4) America/Cuiaba',
  },
  {
    identifier: 'America/Caracas',
    utc_offset: '(UTC-4)',
    combined_info: '(UTC-4) America/Caracas',
  },
  {
    identifier: 'America/Campo_Grande',
    utc_offset: '(UTC-4)',
    combined_info: '(UTC-4) America/Campo_Grande',
  },
  {
    identifier: 'America/Boa_Vista',
    utc_offset: '(UTC-4)',
    combined_info: '(UTC-4) America/Boa_Vista',
  },
  {
    identifier: 'America/Blanc-Sablon',
    utc_offset: '(UTC-4)',
    combined_info: '(UTC-4) America/Blanc-Sablon',
  },
  {
    identifier: 'America/Barbados',
    utc_offset: '(UTC-4)',
    combined_info: '(UTC-4) America/Barbados',
  },
  {
    identifier: 'America/Asuncion',
    utc_offset: '(UTC-4)',
    combined_info: '(UTC-4) America/Asuncion',
  },
  {
    identifier: 'America/Aruba',
    utc_offset: '(UTC-4)',
    combined_info: '(UTC-4) America/Aruba',
  },
  {
    identifier: 'America/Antigua',
    utc_offset: '(UTC-4)',
    combined_info: '(UTC-4) America/Antigua',
  },
  {
    identifier: 'America/Anguilla',
    utc_offset: '(UTC-4)',
    combined_info: '(UTC-4) America/Anguilla',
  },
  {
    identifier: 'America/St_Johns',
    utc_offset: '(UTC-3:30)',
    combined_info: '(UTC-3:30) America/St_Johns',
  },
  {
    identifier: 'Atlantic/Stanley',
    utc_offset: '(UTC-3)',
    combined_info: '(UTC-3) Atlantic/Stanley',
  },
  {
    identifier: 'Antarctica/Rothera',
    utc_offset: '(UTC-3)',
    combined_info: '(UTC-3) Antarctica/Rothera',
  },
  {
    identifier: 'Antarctica/Palmer',
    utc_offset: '(UTC-3)',
    combined_info: '(UTC-3) Antarctica/Palmer',
  },
  {
    identifier: 'America/Sao_Paulo',
    utc_offset: '(UTC-3)',
    combined_info: '(UTC-3) America/Sao_Paulo',
  },
  {
    identifier: 'America/Santarem',
    utc_offset: '(UTC-3)',
    combined_info: '(UTC-3) America/Santarem',
  },
  {
    identifier: 'America/Recife',
    utc_offset: '(UTC-3)',
    combined_info: '(UTC-3) America/Recife',
  },
  {
    identifier: 'America/Punta_Arenas',
    utc_offset: '(UTC-3)',
    combined_info: '(UTC-3) America/Punta_Arenas',
  },
  {
    identifier: 'America/Paramaribo',
    utc_offset: '(UTC-3)',
    combined_info: '(UTC-3) America/Paramaribo',
  },
  {
    identifier: 'America/Montevideo',
    utc_offset: '(UTC-3)',
    combined_info: '(UTC-3) America/Montevideo',
  },
  {
    identifier: 'America/Miquelon',
    utc_offset: '(UTC-3)',
    combined_info: '(UTC-3) America/Miquelon',
  },
  {
    identifier: 'America/Maceio',
    utc_offset: '(UTC-3)',
    combined_info: '(UTC-3) America/Maceio',
  },
  {
    identifier: 'America/Godthab',
    utc_offset: '(UTC-3)',
    combined_info: '(UTC-3) America/Godthab',
  },
  {
    identifier: 'America/Fortaleza',
    utc_offset: '(UTC-3)',
    combined_info: '(UTC-3) America/Fortaleza',
  },
  {
    identifier: 'America/Cayenne',
    utc_offset: '(UTC-3)',
    combined_info: '(UTC-3) America/Cayenne',
  },
  {
    identifier: 'America/Belem',
    utc_offset: '(UTC-3)',
    combined_info: '(UTC-3) America/Belem',
  },
  {
    identifier: 'America/Bahia',
    utc_offset: '(UTC-3)',
    combined_info: '(UTC-3) America/Bahia',
  },
  {
    identifier: 'America/Argentina/Ushuaia',
    utc_offset: '(UTC-3)',
    combined_info: '(UTC-3) America/Argentina/Ushuaia',
  },
  {
    identifier: 'America/Argentina/Tucuman',
    utc_offset: '(UTC-3)',
    combined_info: '(UTC-3) America/Argentina/Tucuman',
  },
  {
    identifier: 'America/Argentina/San_Luis',
    utc_offset: '(UTC-3)',
    combined_info: '(UTC-3) America/Argentina/San_Luis',
  },
  {
    identifier: 'America/Argentina/San_Juan',
    utc_offset: '(UTC-3)',
    combined_info: '(UTC-3) America/Argentina/San_Juan',
  },
  {
    identifier: 'America/Argentina/Salta',
    utc_offset: '(UTC-3)',
    combined_info: '(UTC-3) America/Argentina/Salta',
  },
  {
    identifier: 'America/Argentina/Rio_Gallegos',
    utc_offset: '(UTC-3)',
    combined_info: '(UTC-3) America/Argentina/Rio_Gallegos',
  },
  {
    identifier: 'America/Argentina/Mendoza',
    utc_offset: '(UTC-3)',
    combined_info: '(UTC-3) America/Argentina/Mendoza',
  },
  {
    identifier: 'America/Argentina/La_Rioja',
    utc_offset: '(UTC-3)',
    combined_info: '(UTC-3) America/Argentina/La_Rioja',
  },
  {
    identifier: 'America/Argentina/Jujuy',
    utc_offset: '(UTC-3)',
    combined_info: '(UTC-3) America/Argentina/Jujuy',
  },
  {
    identifier: 'America/Argentina/Cordoba',
    utc_offset: '(UTC-3)',
    combined_info: '(UTC-3) America/Argentina/Cordoba',
  },
  {
    identifier: 'America/Argentina/Catamarca',
    utc_offset: '(UTC-3)',
    combined_info: '(UTC-3) America/Argentina/Catamarca',
  },
  {
    identifier: 'America/Argentina/Buenos_Aires',
    utc_offset: '(UTC-3)',
    combined_info: '(UTC-3) America/Argentina/Buenos_Aires',
  },
  {
    identifier: 'America/Araguaina',
    utc_offset: '(UTC-3)',
    combined_info: '(UTC-3) America/Araguaina',
  },
  {
    identifier: 'Atlantic/South_Georgia',
    utc_offset: '(UTC-2)',
    combined_info: '(UTC-2) Atlantic/South_Georgia',
  },
  {
    identifier: 'America/Noronha',
    utc_offset: '(UTC-2)',
    combined_info: '(UTC-2) America/Noronha',
  },
  {
    identifier: 'Pacific/Pago_Pago',
    utc_offset: '(UTC-11)',
    combined_info: '(UTC-11) Pacific/Pago_Pago',
  },
  {
    identifier: 'Pacific/Niue',
    utc_offset: '(UTC-11)',
    combined_info: '(UTC-11) Pacific/Niue',
  },
  {
    identifier: 'Pacific/Midway',
    utc_offset: '(UTC-11)',
    combined_info: '(UTC-11) Pacific/Midway',
  },
  {
    identifier: 'Pacific/Tahiti',
    utc_offset: '(UTC-10)',
    combined_info: '(UTC-10) Pacific/Tahiti',
  },
  {
    identifier: 'Pacific/Rarotonga',
    utc_offset: '(UTC-10)',
    combined_info: '(UTC-10) Pacific/Rarotonga',
  },
  {
    identifier: 'Pacific/Honolulu',
    utc_offset: '(UTC-10)',
    combined_info: '(UTC-10) Pacific/Honolulu',
  },
  {
    identifier: 'America/Adak',
    utc_offset: '(UTC-10)',
    combined_info: '(UTC-10) America/Adak',
  },
  {
    identifier: 'Atlantic/Cape_Verde',
    utc_offset: '(UTC-1)',
    combined_info: '(UTC-1) Atlantic/Cape_Verde',
  },
  {
    identifier: 'Atlantic/Azores',
    utc_offset: '(UTC-1)',
    combined_info: '(UTC-1) Atlantic/Azores',
  },
  {
    identifier: 'America/Scoresbysund',
    utc_offset: '(UTC-1)',
    combined_info: '(UTC-1) America/Scoresbysund',
  },
  {
    identifier: 'Africa/Abidjan',
    utc_offset: '(UTC+0)',
    combined_info: '(UTC+0) Africa/Abidjan',
  },
  {
    identifier: 'Africa/Accra',
    utc_offset: '(UTC+0)',
    combined_info: '(UTC+0) Africa/Accra',
  },
  {
    identifier: 'Africa/Bamako',
    utc_offset: '(UTC+0)',
    combined_info: '(UTC+0) Africa/Bamako',
  },
  {
    identifier: 'Africa/Banjul',
    utc_offset: '(UTC+0)',
    combined_info: '(UTC+0) Africa/Banjul',
  },
  {
    identifier: 'Africa/Bissau',
    utc_offset: '(UTC+0)',
    combined_info: '(UTC+0) Africa/Bissau',
  },
  {
    identifier: 'Africa/Casablanca',
    utc_offset: '(UTC+0)',
    combined_info: '(UTC+0) Africa/Casablanca',
  },
  {
    identifier: 'Africa/Conakry',
    utc_offset: '(UTC+0)',
    combined_info: '(UTC+0) Africa/Conakry',
  },
  {
    identifier: 'Africa/Dakar',
    utc_offset: '(UTC+0)',
    combined_info: '(UTC+0) Africa/Dakar',
  },
  {
    identifier: 'Africa/El_Aaiun',
    utc_offset: '(UTC+0)',
    combined_info: '(UTC+0) Africa/El_Aaiun',
  },
  {
    identifier: 'Africa/Freetown',
    utc_offset: '(UTC+0)',
    combined_info: '(UTC+0) Africa/Freetown',
  },
  {
    identifier: 'Africa/Lome',
    utc_offset: '(UTC+0)',
    combined_info: '(UTC+0) Africa/Lome',
  },
  {
    identifier: 'Africa/Monrovia',
    utc_offset: '(UTC+0)',
    combined_info: '(UTC+0) Africa/Monrovia',
  },
  {
    identifier: 'Africa/Nouakchott',
    utc_offset: '(UTC+0)',
    combined_info: '(UTC+0) Africa/Nouakchott',
  },
  {
    identifier: 'Africa/Ouagadougou',
    utc_offset: '(UTC+0)',
    combined_info: '(UTC+0) Africa/Ouagadougou',
  },
  {
    identifier: 'Africa/Sao_Tome',
    utc_offset: '(UTC+0)',
    combined_info: '(UTC+0) Africa/Sao_Tome',
  },
  {
    identifier: 'America/Danmarkshavn',
    utc_offset: '(UTC+0)',
    combined_info: '(UTC+0) America/Danmarkshavn',
  },
  {
    identifier: 'Antarctica/Troll',
    utc_offset: '(UTC+0)',
    combined_info: '(UTC+0) Antarctica/Troll',
  },
  {
    identifier: 'Atlantic/Canary',
    utc_offset: '(UTC+0)',
    combined_info: '(UTC+0) Atlantic/Canary',
  },
  {
    identifier: 'Atlantic/Faroe',
    utc_offset: '(UTC+0)',
    combined_info: '(UTC+0) Atlantic/Faroe',
  },
  {
    identifier: 'Atlantic/Madeira',
    utc_offset: '(UTC+0)',
    combined_info: '(UTC+0) Atlantic/Madeira',
  },
  {
    identifier: 'Atlantic/Reykjavik',
    utc_offset: '(UTC+0)',
    combined_info: '(UTC+0) Atlantic/Reykjavik',
  },
  {
    identifier: 'Atlantic/St_Helena',
    utc_offset: '(UTC+0)',
    combined_info: '(UTC+0) Atlantic/St_Helena',
  },
  {
    identifier: 'Europe/Dublin',
    utc_offset: '(UTC+0)',
    combined_info: '(UTC+0) Europe/Dublin',
  },
  {
    identifier: 'Europe/Guernsey',
    utc_offset: '(UTC+0)',
    combined_info: '(UTC+0) Europe/Guernsey',
  },
  {
    identifier: 'Europe/Isle_of_Man',
    utc_offset: '(UTC+0)',
    combined_info: '(UTC+0) Europe/Isle_of_Man',
  },
  {
    identifier: 'Europe/Jersey',
    utc_offset: '(UTC+0)',
    combined_info: '(UTC+0) Europe/Jersey',
  },
  {
    identifier: 'Europe/Lisbon',
    utc_offset: '(UTC+0)',
    combined_info: '(UTC+0) Europe/Lisbon',
  },
  {
    identifier: 'Europe/London',
    utc_offset: '(UTC+0)',
    combined_info: '(UTC+0) Europe/London',
  },
  {
    identifier: 'Africa/Algiers',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Africa/Algiers',
  },
  {
    identifier: 'Africa/Bangui',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Africa/Bangui',
  },
  {
    identifier: 'Africa/Brazzaville',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Africa/Brazzaville',
  },
  {
    identifier: 'Africa/Ceuta',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Africa/Ceuta',
  },
  {
    identifier: 'Africa/Douala',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Africa/Douala',
  },
  {
    identifier: 'Africa/Kinshasa',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Africa/Kinshasa',
  },
  {
    identifier: 'Africa/Lagos',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Africa/Lagos',
  },
  {
    identifier: 'Africa/Libreville',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Africa/Libreville',
  },
  {
    identifier: 'Africa/Luanda',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Africa/Luanda',
  },
  {
    identifier: 'Africa/Malabo',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Africa/Malabo',
  },
  {
    identifier: 'Africa/Ndjamena',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Africa/Ndjamena',
  },
  {
    identifier: 'Africa/Niamey',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Africa/Niamey',
  },
  {
    identifier: 'Africa/Porto-Novo',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Africa/Porto-Novo',
  },
  {
    identifier: 'Africa/Tunis',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Africa/Tunis',
  },
  {
    identifier: 'Africa/Windhoek',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Africa/Windhoek',
  },
  {
    identifier: 'Arctic/Longyearbyen',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Arctic/Longyearbyen',
  },
  {
    identifier: 'Europe/Amsterdam',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Europe/Amsterdam',
  },
  {
    identifier: 'Europe/Andorra',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Europe/Andorra',
  },
  {
    identifier: 'Europe/Belgrade',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Europe/Belgrade',
  },
  {
    identifier: 'Europe/Berlin',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Europe/Berlin',
  },
  {
    identifier: 'Europe/Bratislava',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Europe/Bratislava',
  },
  {
    identifier: 'Europe/Brussels',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Europe/Brussels',
  },
  {
    identifier: 'Europe/Budapest',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Europe/Budapest',
  },
  {
    identifier: 'Europe/Copenhagen',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Europe/Copenhagen',
  },
  {
    identifier: 'Europe/Gibraltar',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Europe/Gibraltar',
  },
  {
    identifier: 'Europe/Ljubljana',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Europe/Ljubljana',
  },
  {
    identifier: 'Europe/Luxembourg',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Europe/Luxembourg',
  },
  {
    identifier: 'Europe/Madrid',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Europe/Madrid',
  },
  {
    identifier: 'Europe/Malta',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Europe/Malta',
  },
  {
    identifier: 'Europe/Monaco',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Europe/Monaco',
  },
  {
    identifier: 'Europe/Oslo',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Europe/Oslo',
  },
  {
    identifier: 'Europe/Paris',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Europe/Paris',
  },
  {
    identifier: 'Europe/Podgorica',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Europe/Podgorica',
  },
  {
    identifier: 'Europe/Prague',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Europe/Prague',
  },
  {
    identifier: 'Europe/Rome',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Europe/Rome',
  },
  {
    identifier: 'Europe/San_Marino',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Europe/San_Marino',
  },
  {
    identifier: 'Europe/Sarajevo',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Europe/Sarajevo',
  },
  {
    identifier: 'Europe/Skopje',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Europe/Skopje',
  },
  {
    identifier: 'Europe/Stockholm',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Europe/Stockholm',
  },
  {
    identifier: 'Europe/Tirane',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Europe/Tirane',
  },
  {
    identifier: 'Europe/Vaduz',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Europe/Vaduz',
  },
  {
    identifier: 'Europe/Vatican',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Europe/Vatican',
  },
  {
    identifier: 'Europe/Vienna',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Europe/Vienna',
  },
  {
    identifier: 'Europe/Warsaw',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Europe/Warsaw',
  },
  {
    identifier: 'Europe/Zagreb',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Europe/Zagreb',
  },
  {
    identifier: 'Europe/Zurich',
    utc_offset: '(UTC+1)',
    combined_info: '(UTC+1) Europe/Zurich',
  },
  {
    identifier: 'Africa/Blantyre',
    utc_offset: '(UTC+2)',
    combined_info: '(UTC+2) Africa/Blantyre',
  },
  {
    identifier: 'Africa/Bujumbura',
    utc_offset: '(UTC+2)',
    combined_info: '(UTC+2) Africa/Bujumbura',
  },
  {
    identifier: 'Africa/Cairo',
    utc_offset: '(UTC+2)',
    combined_info: '(UTC+2) Africa/Cairo',
  },
  {
    identifier: 'Africa/Gaborone',
    utc_offset: '(UTC+2)',
    combined_info: '(UTC+2) Africa/Gaborone',
  },
  {
    identifier: 'Africa/Harare',
    utc_offset: '(UTC+2)',
    combined_info: '(UTC+2) Africa/Harare',
  },
  {
    identifier: 'Africa/Johannesburg',
    utc_offset: '(UTC+2)',
    combined_info: '(UTC+2) Africa/Johannesburg',
  },
  {
    identifier: 'Africa/Juba',
    utc_offset: '(UTC+2)',
    combined_info: '(UTC+2) Africa/Juba',
  },
  {
    identifier: 'Africa/Khartoum',
    utc_offset: '(UTC+2)',
    combined_info: '(UTC+2) Africa/Khartoum',
  },
  {
    identifier: 'Africa/Kigali',
    utc_offset: '(UTC+2)',
    combined_info: '(UTC+2) Africa/Kigali',
  },
  {
    identifier: 'Africa/Lubumbashi',
    utc_offset: '(UTC+2)',
    combined_info: '(UTC+2) Africa/Lubumbashi',
  },
  {
    identifier: 'Africa/Lusaka',
    utc_offset: '(UTC+2)',
    combined_info: '(UTC+2) Africa/Lusaka',
  },
  {
    identifier: 'Africa/Maputo',
    utc_offset: '(UTC+2)',
    combined_info: '(UTC+2) Africa/Maputo',
  },
  {
    identifier: 'Africa/Maseru',
    utc_offset: '(UTC+2)',
    combined_info: '(UTC+2) Africa/Maseru',
  },
  {
    identifier: 'Africa/Mbabane',
    utc_offset: '(UTC+2)',
    combined_info: '(UTC+2) Africa/Mbabane',
  },
  {
    identifier: 'Africa/Tripoli',
    utc_offset: '(UTC+2)',
    combined_info: '(UTC+2) Africa/Tripoli',
  },
  {
    identifier: 'Asia/Amman',
    utc_offset: '(UTC+2)',
    combined_info: '(UTC+2) Asia/Amman',
  },
  {
    identifier: 'Asia/Beirut',
    utc_offset: '(UTC+2)',
    combined_info: '(UTC+2) Asia/Beirut',
  },
  {
    identifier: 'Asia/Damascus',
    utc_offset: '(UTC+2)',
    combined_info: '(UTC+2) Asia/Damascus',
  },
  {
    identifier: 'Asia/Famagusta',
    utc_offset: '(UTC+2)',
    combined_info: '(UTC+2) Asia/Famagusta',
  },
  {
    identifier: 'Asia/Gaza',
    utc_offset: '(UTC+2)',
    combined_info: '(UTC+2) Asia/Gaza',
  },
  {
    identifier: 'Asia/Hebron',
    utc_offset: '(UTC+2)',
    combined_info: '(UTC+2) Asia/Hebron',
  },
  {
    identifier: 'Asia/Jerusalem',
    utc_offset: '(UTC+2)',
    combined_info: '(UTC+2) Asia/Jerusalem',
  },
  {
    identifier: 'Asia/Nicosia',
    utc_offset: '(UTC+2)',
    combined_info: '(UTC+2) Asia/Nicosia',
  },
  {
    identifier: 'Europe/Athens',
    utc_offset: '(UTC+2)',
    combined_info: '(UTC+2) Europe/Athens',
  },
  {
    identifier: 'Europe/Bucharest',
    utc_offset: '(UTC+2)',
    combined_info: '(UTC+2) Europe/Bucharest',
  },
  {
    identifier: 'Europe/Chisinau',
    utc_offset: '(UTC+2)',
    combined_info: '(UTC+2) Europe/Chisinau',
  },
  {
    identifier: 'Europe/Helsinki',
    utc_offset: '(UTC+2)',
    combined_info: '(UTC+2) Europe/Helsinki',
  },
  {
    identifier: 'Europe/Kaliningrad',
    utc_offset: '(UTC+2)',
    combined_info: '(UTC+2) Europe/Kaliningrad',
  },
  {
    identifier: 'Europe/Kiev',
    utc_offset: '(UTC+2)',
    combined_info: '(UTC+2) Europe/Kiev',
  },
  {
    identifier: 'Europe/Mariehamn',
    utc_offset: '(UTC+2)',
    combined_info: '(UTC+2) Europe/Mariehamn',
  },
  {
    identifier: 'Europe/Riga',
    utc_offset: '(UTC+2)',
    combined_info: '(UTC+2) Europe/Riga',
  },
  {
    identifier: 'Europe/Sofia',
    utc_offset: '(UTC+2)',
    combined_info: '(UTC+2) Europe/Sofia',
  },
  {
    identifier: 'Europe/Tallinn',
    utc_offset: '(UTC+2)',
    combined_info: '(UTC+2) Europe/Tallinn',
  },
  {
    identifier: 'Europe/Uzhgorod',
    utc_offset: '(UTC+2)',
    combined_info: '(UTC+2) Europe/Uzhgorod',
  },
  {
    identifier: 'Europe/Vilnius',
    utc_offset: '(UTC+2)',
    combined_info: '(UTC+2) Europe/Vilnius',
  },
  {
    identifier: 'Europe/Zaporozhye',
    utc_offset: '(UTC+2)',
    combined_info: '(UTC+2) Europe/Zaporozhye',
  },
  {
    identifier: 'Africa/Addis_Ababa',
    utc_offset: '(UTC+3)',
    combined_info: '(UTC+3) Africa/Addis_Ababa',
  },
  {
    identifier: 'Africa/Asmara',
    utc_offset: '(UTC+3)',
    combined_info: '(UTC+3) Africa/Asmara',
  },
  {
    identifier: 'Africa/Dar_es_Salaam',
    utc_offset: '(UTC+3)',
    combined_info: '(UTC+3) Africa/Dar_es_Salaam',
  },
  {
    identifier: 'Africa/Djibouti',
    utc_offset: '(UTC+3)',
    combined_info: '(UTC+3) Africa/Djibouti',
  },
  {
    identifier: 'Africa/Kampala',
    utc_offset: '(UTC+3)',
    combined_info: '(UTC+3) Africa/Kampala',
  },
  {
    identifier: 'Africa/Mogadishu',
    utc_offset: '(UTC+3)',
    combined_info: '(UTC+3) Africa/Mogadishu',
  },
  {
    identifier: 'Africa/Nairobi',
    utc_offset: '(UTC+3)',
    combined_info: '(UTC+3) Africa/Nairobi',
  },
  {
    identifier: 'Antarctica/Syowa',
    utc_offset: '(UTC+3)',
    combined_info: '(UTC+3) Antarctica/Syowa',
  },
  {
    identifier: 'Asia/Aden',
    utc_offset: '(UTC+3)',
    combined_info: '(UTC+3) Asia/Aden',
  },
  {
    identifier: 'Asia/Baghdad',
    utc_offset: '(UTC+3)',
    combined_info: '(UTC+3) Asia/Baghdad',
  },
  {
    identifier: 'Asia/Bahrain',
    utc_offset: '(UTC+3)',
    combined_info: '(UTC+3) Asia/Bahrain',
  },
  {
    identifier: 'Asia/Kuwait',
    utc_offset: '(UTC+3)',
    combined_info: '(UTC+3) Asia/Kuwait',
  },
  {
    identifier: 'Asia/Qatar',
    utc_offset: '(UTC+3)',
    combined_info: '(UTC+3) Asia/Qatar',
  },
  {
    identifier: 'Asia/Riyadh',
    utc_offset: '(UTC+3)',
    combined_info: '(UTC+3) Asia/Riyadh',
  },
  {
    identifier: 'Europe/Istanbul',
    utc_offset: '(UTC+3)',
    combined_info: '(UTC+3) Europe/Istanbul',
  },
  {
    identifier: 'Europe/Kirov',
    utc_offset: '(UTC+3)',
    combined_info: '(UTC+3) Europe/Kirov',
  },
  {
    identifier: 'Europe/Minsk',
    utc_offset: '(UTC+3)',
    combined_info: '(UTC+3) Europe/Minsk',
  },
  {
    identifier: 'Europe/Moscow',
    utc_offset: '(UTC+3)',
    combined_info: '(UTC+3) Europe/Moscow',
  },
  {
    identifier: 'Europe/Simferopol',
    utc_offset: '(UTC+3)',
    combined_info: '(UTC+3) Europe/Simferopol',
  },
  {
    identifier: 'Europe/Volgograd',
    utc_offset: '(UTC+3)',
    combined_info: '(UTC+3) Europe/Volgograd',
  },
  {
    identifier: 'Indian/Antananarivo',
    utc_offset: '(UTC+3)',
    combined_info: '(UTC+3) Indian/Antananarivo',
  },
  {
    identifier: 'Indian/Comoro',
    utc_offset: '(UTC+3)',
    combined_info: '(UTC+3) Indian/Comoro',
  },
  {
    identifier: 'Indian/Mayotte',
    utc_offset: '(UTC+3)',
    combined_info: '(UTC+3) Indian/Mayotte',
  },
  {
    identifier: 'Asia/Tehran',
    utc_offset: '(UTC+3:30)',
    combined_info: '(UTC+3:30) Asia/Tehran',
  },
  {
    identifier: 'Asia/Baku',
    utc_offset: '(UTC+4)',
    combined_info: '(UTC+4) Asia/Baku',
  },
  {
    identifier: 'Asia/Dubai',
    utc_offset: '(UTC+4)',
    combined_info: '(UTC+4) Asia/Dubai',
  },
  {
    identifier: 'Asia/Muscat',
    utc_offset: '(UTC+4)',
    combined_info: '(UTC+4) Asia/Muscat',
  },
  {
    identifier: 'Asia/Tbilisi',
    utc_offset: '(UTC+4)',
    combined_info: '(UTC+4) Asia/Tbilisi',
  },
  {
    identifier: 'Asia/Yerevan',
    utc_offset: '(UTC+4)',
    combined_info: '(UTC+4) Asia/Yerevan',
  },
  {
    identifier: 'Europe/Astrakhan',
    utc_offset: '(UTC+4)',
    combined_info: '(UTC+4) Europe/Astrakhan',
  },
  {
    identifier: 'Europe/Samara',
    utc_offset: '(UTC+4)',
    combined_info: '(UTC+4) Europe/Samara',
  },
  {
    identifier: 'Europe/Saratov',
    utc_offset: '(UTC+4)',
    combined_info: '(UTC+4) Europe/Saratov',
  },
  {
    identifier: 'Europe/Ulyanovsk',
    utc_offset: '(UTC+4)',
    combined_info: '(UTC+4) Europe/Ulyanovsk',
  },
  {
    identifier: 'Indian/Mahe',
    utc_offset: '(UTC+4)',
    combined_info: '(UTC+4) Indian/Mahe',
  },
  {
    identifier: 'Indian/Mauritius',
    utc_offset: '(UTC+4)',
    combined_info: '(UTC+4) Indian/Mauritius',
  },
  {
    identifier: 'Indian/Reunion',
    utc_offset: '(UTC+4)',
    combined_info: '(UTC+4) Indian/Reunion',
  },
  {
    identifier: 'Asia/Kabul',
    utc_offset: '(UTC+4:30)',
    combined_info: '(UTC+4:30) Asia/Kabul',
  },
  {
    identifier: 'Antarctica/Mawson',
    utc_offset: '(UTC+5)',
    combined_info: '(UTC+5) Antarctica/Mawson',
  },
  {
    identifier: 'Asia/Aqtau',
    utc_offset: '(UTC+5)',
    combined_info: '(UTC+5) Asia/Aqtau',
  },
  {
    identifier: 'Asia/Aqtobe',
    utc_offset: '(UTC+5)',
    combined_info: '(UTC+5) Asia/Aqtobe',
  },
  {
    identifier: 'Asia/Ashgabat',
    utc_offset: '(UTC+5)',
    combined_info: '(UTC+5) Asia/Ashgabat',
  },
  {
    identifier: 'Asia/Atyrau',
    utc_offset: '(UTC+5)',
    combined_info: '(UTC+5) Asia/Atyrau',
  },
  {
    identifier: 'Asia/Dushanbe',
    utc_offset: '(UTC+5)',
    combined_info: '(UTC+5) Asia/Dushanbe',
  },
  {
    identifier: 'Asia/Karachi',
    utc_offset: '(UTC+5)',
    combined_info: '(UTC+5) Asia/Karachi',
  },
  {
    identifier: 'Asia/Oral',
    utc_offset: '(UTC+5)',
    combined_info: '(UTC+5) Asia/Oral',
  },
  {
    identifier: 'Asia/Qyzylorda',
    utc_offset: '(UTC+5)',
    combined_info: '(UTC+5) Asia/Qyzylorda',
  },
  {
    identifier: 'Asia/Samarkand',
    utc_offset: '(UTC+5)',
    combined_info: '(UTC+5) Asia/Samarkand',
  },
  {
    identifier: 'Asia/Tashkent',
    utc_offset: '(UTC+5)',
    combined_info: '(UTC+5) Asia/Tashkent',
  },
  {
    identifier: 'Asia/Yekaterinburg',
    utc_offset: '(UTC+5)',
    combined_info: '(UTC+5) Asia/Yekaterinburg',
  },
  {
    identifier: 'Indian/Kerguelen',
    utc_offset: '(UTC+5)',
    combined_info: '(UTC+5) Indian/Kerguelen',
  },
  {
    identifier: 'Indian/Maldives',
    utc_offset: '(UTC+5)',
    combined_info: '(UTC+5) Indian/Maldives',
  },
  {
    identifier: 'Asia/Colombo',
    utc_offset: '(UTC+5:30)',
    combined_info: '(UTC+5:30) Asia/Colombo',
  },
  {
    identifier: 'Asia/Kolkata',
    utc_offset: '(UTC+5:30)',
    combined_info: '(UTC+5:30) Asia/Kolkata',
  },
  {
    identifier: 'Asia/Kathmandu',
    utc_offset: '(UTC+5:45)',
    combined_info: '(UTC+5:45) Asia/Kathmandu',
  },
  {
    identifier: 'Antarctica/Vostok',
    utc_offset: '(UTC+6)',
    combined_info: '(UTC+6) Antarctica/Vostok',
  },
  {
    identifier: 'Asia/Almaty',
    utc_offset: '(UTC+6)',
    combined_info: '(UTC+6) Asia/Almaty',
  },
  {
    identifier: 'Asia/Bishkek',
    utc_offset: '(UTC+6)',
    combined_info: '(UTC+6) Asia/Bishkek',
  },
  {
    identifier: 'Asia/Dhaka',
    utc_offset: '(UTC+6)',
    combined_info: '(UTC+6) Asia/Dhaka',
  },
  {
    identifier: 'Asia/Omsk',
    utc_offset: '(UTC+6)',
    combined_info: '(UTC+6) Asia/Omsk',
  },
  {
    identifier: 'Asia/Qostanay',
    utc_offset: '(UTC+6)',
    combined_info: '(UTC+6) Asia/Qostanay',
  },
  {
    identifier: 'Asia/Thimphu',
    utc_offset: '(UTC+6)',
    combined_info: '(UTC+6) Asia/Thimphu',
  },
  {
    identifier: 'Asia/Urumqi',
    utc_offset: '(UTC+6)',
    combined_info: '(UTC+6) Asia/Urumqi',
  },
  {
    identifier: 'Indian/Chagos',
    utc_offset: '(UTC+6)',
    combined_info: '(UTC+6) Indian/Chagos',
  },
  {
    identifier: 'Asia/Yangon',
    utc_offset: '(UTC+6:30)',
    combined_info: '(UTC+6:30) Asia/Yangon',
  },
  {
    identifier: 'Indian/Cocos',
    utc_offset: '(UTC+6:30)',
    combined_info: '(UTC+6:30) Indian/Cocos',
  },
  {
    identifier: 'Antarctica/Davis',
    utc_offset: '(UTC+7)',
    combined_info: '(UTC+7) Antarctica/Davis',
  },
  {
    identifier: 'Asia/Bangkok',
    utc_offset: '(UTC+7)',
    combined_info: '(UTC+7) Asia/Bangkok',
  },
  {
    identifier: 'Asia/Barnaul',
    utc_offset: '(UTC+7)',
    combined_info: '(UTC+7) Asia/Barnaul',
  },
  {
    identifier: 'Asia/Ho_Chi_Minh',
    utc_offset: '(UTC+7)',
    combined_info: '(UTC+7) Asia/Ho_Chi_Minh',
  },
  {
    identifier: 'Asia/Hovd',
    utc_offset: '(UTC+7)',
    combined_info: '(UTC+7) Asia/Hovd',
  },
  {
    identifier: 'Asia/Jakarta',
    utc_offset: '(UTC+7)',
    combined_info: '(UTC+7) Asia/Jakarta',
  },
  {
    identifier: 'Asia/Krasnoyarsk',
    utc_offset: '(UTC+7)',
    combined_info: '(UTC+7) Asia/Krasnoyarsk',
  },
  {
    identifier: 'Asia/Novokuznetsk',
    utc_offset: '(UTC+7)',
    combined_info: '(UTC+7) Asia/Novokuznetsk',
  },
  {
    identifier: 'Asia/Novosibirsk',
    utc_offset: '(UTC+7)',
    combined_info: '(UTC+7) Asia/Novosibirsk',
  },
  {
    identifier: 'Asia/Phnom_Penh',
    utc_offset: '(UTC+7)',
    combined_info: '(UTC+7) Asia/Phnom_Penh',
  },
  {
    identifier: 'Asia/Pontianak',
    utc_offset: '(UTC+7)',
    combined_info: '(UTC+7) Asia/Pontianak',
  },
  {
    identifier: 'Asia/Tomsk',
    utc_offset: '(UTC+7)',
    combined_info: '(UTC+7) Asia/Tomsk',
  },
  {
    identifier: 'Asia/Vientiane',
    utc_offset: '(UTC+7)',
    combined_info: '(UTC+7) Asia/Vientiane',
  },
  {
    identifier: 'Indian/Christmas',
    utc_offset: '(UTC+7)',
    combined_info: '(UTC+7) Indian/Christmas',
  },
  {
    identifier: 'Asia/Brunei',
    utc_offset: '(UTC+8)',
    combined_info: '(UTC+8) Asia/Brunei',
  },
  {
    identifier: 'Asia/Choibalsan',
    utc_offset: '(UTC+8)',
    combined_info: '(UTC+8) Asia/Choibalsan',
  },
  {
    identifier: 'Asia/Hong_Kong',
    utc_offset: '(UTC+8)',
    combined_info: '(UTC+8) Asia/Hong_Kong',
  },
  {
    identifier: 'Asia/Irkutsk',
    utc_offset: '(UTC+8)',
    combined_info: '(UTC+8) Asia/Irkutsk',
  },
  {
    identifier: 'Asia/Kuala_Lumpur',
    utc_offset: '(UTC+8)',
    combined_info: '(UTC+8) Asia/Kuala_Lumpur',
  },
  {
    identifier: 'Asia/Kuching',
    utc_offset: '(UTC+8)',
    combined_info: '(UTC+8) Asia/Kuching',
  },
  {
    identifier: 'Asia/Macau',
    utc_offset: '(UTC+8)',
    combined_info: '(UTC+8) Asia/Macau',
  },
  {
    identifier: 'Asia/Makassar',
    utc_offset: '(UTC+8)',
    combined_info: '(UTC+8) Asia/Makassar',
  },
  {
    identifier: 'Asia/Manila',
    utc_offset: '(UTC+8)',
    combined_info: '(UTC+8) Asia/Manila',
  },
  {
    identifier: 'Asia/Shanghai',
    utc_offset: '(UTC+8)',
    combined_info: '(UTC+8) Asia/Shanghai',
  },
  {
    identifier: 'Asia/Singapore',
    utc_offset: '(UTC+8)',
    combined_info: '(UTC+8) Asia/Singapore',
  },
  {
    identifier: 'Asia/Taipei',
    utc_offset: '(UTC+8)',
    combined_info: '(UTC+8) Asia/Taipei',
  },
  {
    identifier: 'Asia/Ulaanbaatar',
    utc_offset: '(UTC+8)',
    combined_info: '(UTC+8) Asia/Ulaanbaatar',
  },
  {
    identifier: 'Australia/Perth',
    utc_offset: '(UTC+8)',
    combined_info: '(UTC+8) Australia/Perth',
  },
  {
    identifier: 'Australia/Eucla',
    utc_offset: '(UTC+8:45)',
    combined_info: '(UTC+8:45) Australia/Eucla',
  },
  {
    identifier: 'Asia/Chita',
    utc_offset: '(UTC+9)',
    combined_info: '(UTC+9) Asia/Chita',
  },
  {
    identifier: 'Asia/Dili',
    utc_offset: '(UTC+9)',
    combined_info: '(UTC+9) Asia/Dili',
  },
  {
    identifier: 'Asia/Jayapura',
    utc_offset: '(UTC+9)',
    combined_info: '(UTC+9) Asia/Jayapura',
  },
  {
    identifier: 'Asia/Khandyga',
    utc_offset: '(UTC+9)',
    combined_info: '(UTC+9) Asia/Khandyga',
  },
  {
    identifier: 'Asia/Pyongyang',
    utc_offset: '(UTC+9)',
    combined_info: '(UTC+9) Asia/Pyongyang',
  },
  {
    identifier: 'Asia/Seoul',
    utc_offset: '(UTC+9)',
    combined_info: '(UTC+9) Asia/Seoul',
  },
  {
    identifier: 'Asia/Tokyo',
    utc_offset: '(UTC+9)',
    combined_info: '(UTC+9) Asia/Tokyo',
  },
  {
    identifier: 'Asia/Yakutsk',
    utc_offset: '(UTC+9)',
    combined_info: '(UTC+9) Asia/Yakutsk',
  },
  {
    identifier: 'Pacific/Palau',
    utc_offset: '(UTC+9)',
    combined_info: '(UTC+9) Pacific/Palau',
  },
  {
    identifier: 'Australia/Adelaide',
    utc_offset: '(UTC+9:30)',
    combined_info: '(UTC+9:30) Australia/Adelaide',
  },
  {
    identifier: 'Australia/Broken_Hill',
    utc_offset: '(UTC+9:30)',
    combined_info: '(UTC+9:30) Australia/Broken_Hill',
  },
  {
    identifier: 'Australia/Darwin',
    utc_offset: '(UTC+9:30)',
    combined_info: '(UTC+9:30) Australia/Darwin',
  },
  {
    identifier: 'Antarctica/DumontDUrville',
    utc_offset: '(UTC+10)',
    combined_info: '(UTC+10) Antarctica/DumontDUrville',
  },
  {
    identifier: 'Antarctica/Macquarie',
    utc_offset: '(UTC+10)',
    combined_info: '(UTC+10) Antarctica/Macquarie',
  },
  {
    identifier: 'Asia/Ust-Nera',
    utc_offset: '(UTC+10)',
    combined_info: '(UTC+10) Asia/Ust-Nera',
  },
  {
    identifier: 'Asia/Vladivostok',
    utc_offset: '(UTC+10)',
    combined_info: '(UTC+10) Asia/Vladivostok',
  },
  {
    identifier: 'Australia/Brisbane',
    utc_offset: '(UTC+10)',
    combined_info: '(UTC+10) Australia/Brisbane',
  },
  {
    identifier: 'Australia/Currie',
    utc_offset: '(UTC+10)',
    combined_info: '(UTC+10) Australia/Currie',
  },
  {
    identifier: 'Australia/Hobart',
    utc_offset: '(UTC+10)',
    combined_info: '(UTC+10) Australia/Hobart',
  },
  {
    identifier: 'Australia/Lindeman',
    utc_offset: '(UTC+10)',
    combined_info: '(UTC+10) Australia/Lindeman',
  },
  {
    identifier: 'Australia/Melbourne',
    utc_offset: '(UTC+10)',
    combined_info: '(UTC+10) Australia/Melbourne',
  },
  {
    identifier: 'Australia/Sydney',
    utc_offset: '(UTC+10)',
    combined_info: '(UTC+10) Australia/Sydney',
  },
  {
    identifier: 'Pacific/Chuuk',
    utc_offset: '(UTC+10)',
    combined_info: '(UTC+10) Pacific/Chuuk',
  },
  {
    identifier: 'Pacific/Guam',
    utc_offset: '(UTC+10)',
    combined_info: '(UTC+10) Pacific/Guam',
  },
  {
    identifier: 'Pacific/Port_Moresby',
    utc_offset: '(UTC+10)',
    combined_info: '(UTC+10) Pacific/Port_Moresby',
  },
  {
    identifier: 'Pacific/Saipan',
    utc_offset: '(UTC+10)',
    combined_info: '(UTC+10) Pacific/Saipan',
  },
  {
    identifier: 'Australia/Lord_Howe',
    utc_offset: '(UTC+10:30)',
    combined_info: '(UTC+10:30) Australia/Lord_Howe',
  },
  {
    identifier: 'Antarctica/Casey',
    utc_offset: '(UTC+11)',
    combined_info: '(UTC+11) Antarctica/Casey',
  },
  {
    identifier: 'Asia/Magadan',
    utc_offset: '(UTC+11)',
    combined_info: '(UTC+11) Asia/Magadan',
  },
  {
    identifier: 'Asia/Sakhalin',
    utc_offset: '(UTC+11)',
    combined_info: '(UTC+11) Asia/Sakhalin',
  },
  {
    identifier: 'Asia/Srednekolymsk',
    utc_offset: '(UTC+11)',
    combined_info: '(UTC+11) Asia/Srednekolymsk',
  },
  {
    identifier: 'Pacific/Bougainville',
    utc_offset: '(UTC+11)',
    combined_info: '(UTC+11) Pacific/Bougainville',
  },
  {
    identifier: 'Pacific/Efate',
    utc_offset: '(UTC+11)',
    combined_info: '(UTC+11) Pacific/Efate',
  },
  {
    identifier: 'Pacific/Guadalcanal',
    utc_offset: '(UTC+11)',
    combined_info: '(UTC+11) Pacific/Guadalcanal',
  },
  {
    identifier: 'Pacific/Kosrae',
    utc_offset: '(UTC+11)',
    combined_info: '(UTC+11) Pacific/Kosrae',
  },
  {
    identifier: 'Pacific/Norfolk',
    utc_offset: '(UTC+11)',
    combined_info: '(UTC+11) Pacific/Norfolk',
  },
  {
    identifier: 'Pacific/Noumea',
    utc_offset: '(UTC+11)',
    combined_info: '(UTC+11) Pacific/Noumea',
  },
  {
    identifier: 'Pacific/Pohnpei',
    utc_offset: '(UTC+11)',
    combined_info: '(UTC+11) Pacific/Pohnpei',
  },
  {
    identifier: 'Antarctica/McMurdo',
    utc_offset: '(UTC+12)',
    combined_info: '(UTC+12) Antarctica/McMurdo',
  },
  {
    identifier: 'Asia/Anadyr',
    utc_offset: '(UTC+12)',
    combined_info: '(UTC+12) Asia/Anadyr',
  },
  {
    identifier: 'Asia/Kamchatka',
    utc_offset: '(UTC+12)',
    combined_info: '(UTC+12) Asia/Kamchatka',
  },
  {
    identifier: 'Pacific/Auckland',
    utc_offset: '(UTC+12)',
    combined_info: '(UTC+12) Pacific/Auckland',
  },
  {
    identifier: 'Pacific/Fiji',
    utc_offset: '(UTC+12)',
    combined_info: '(UTC+12) Pacific/Fiji',
  },
  {
    identifier: 'Pacific/Funafuti',
    utc_offset: '(UTC+12)',
    combined_info: '(UTC+12) Pacific/Funafuti',
  },
  {
    identifier: 'Pacific/Kwajalein',
    utc_offset: '(UTC+12)',
    combined_info: '(UTC+12) Pacific/Kwajalein',
  },
  {
    identifier: 'Pacific/Majuro',
    utc_offset: '(UTC+12)',
    combined_info: '(UTC+12) Pacific/Majuro',
  },
  {
    identifier: 'Pacific/Nauru',
    utc_offset: '(UTC+12)',
    combined_info: '(UTC+12) Pacific/Nauru',
  },
  {
    identifier: 'Pacific/Tarawa',
    utc_offset: '(UTC+12)',
    combined_info: '(UTC+12) Pacific/Tarawa',
  },
  {
    identifier: 'Pacific/Wake',
    utc_offset: '(UTC+12)',
    combined_info: '(UTC+12) Pacific/Wake',
  },
  {
    identifier: 'Pacific/Wallis',
    utc_offset: '(UTC+12)',
    combined_info: '(UTC+12) Pacific/Wallis',
  },
  {
    identifier: 'Pacific/Chatham',
    utc_offset: '(UTC+12:45)',
    combined_info: '(UTC+12:45) Pacific/Chatham',
  },
  {
    identifier: 'Pacific/Apia',
    utc_offset: '(UTC+13)',
    combined_info: '(UTC+13) Pacific/Apia',
  },
  {
    identifier: 'Pacific/Enderbury',
    utc_offset: '(UTC+13)',
    combined_info: '(UTC+13) Pacific/Enderbury',
  },
  {
    identifier: 'Pacific/Fakaofo',
    utc_offset: '(UTC+13)',
    combined_info: '(UTC+13) Pacific/Fakaofo',
  },
  {
    identifier: 'Pacific/Tongatapu',
    utc_offset: '(UTC+13)',
    combined_info: '(UTC+13) Pacific/Tongatapu',
  },
  {
    identifier: 'Pacific/Kiritimati',
    utc_offset: '(UTC+14)',
    combined_info: '(UTC+14) Pacific/Kiritimati',
  },
];

export const profileContainerClass = 'profile-container';

export const originalOrderKeyValuePipe = () => 0;

export const emailPattern = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$';

export const defaultDecimalTemplate = '1.0-2';

/** Colour id used when a {@link colorMap} lookup misses (light grey). */
export const defaultColorId = 21;

/**
 * Maps a numeric colour id (1–22, e.g. a task-type `color`) to the TWC helper
 * classes that paint it (Figma `9619-1655` light / `9619-1870` dark). All
 * classes are generated by `twc-color-helpers` from tokens in the theme
 * `variables.scss` files.
 *
 * - `bgColor` / `textColor` paint a label/badge (`twc-color-label`) with the
 *   per-status `*-bg` + `*-fg`/`*-label` token pair, so dark themes can pair
 *   muted backgrounds with pastel text.
 * - `swatchColor` paints a palette square (the colour-manager swatches) with
 *   the raw element colour, and `tickColor` the check mark drawn on top of it.
 */
export const colorMap: Record<number, ColorMap> = {
  1: {
    bgColor: 'twc-bg-color-cobalt-bg',
    textColor: 'twc-color-cobalt-fg',
    swatchColor: 'twc-bg-color-cobalt-blue',
    tickColor: 'twc-color-surface-canvas',
  },
  2: {
    bgColor: 'twc-bg-color-darkblue-bg',
    textColor: 'twc-color-darkblue-label',
    swatchColor: 'twc-bg-color-blue',
    tickColor: 'twc-color-darkblue-label',
  },
  3: {
    bgColor: 'twc-bg-color-skyblue-bg',
    textColor: 'twc-color-skyblue-fg',
    swatchColor: 'twc-bg-color-sky-blue',
    tickColor: 'twc-color-skyblue-fg',
  },
  4: {
    bgColor: 'twc-bg-color-green-bg',
    textColor: 'twc-color-green-label',
    swatchColor: 'twc-bg-color-green',
    tickColor: 'twc-color-green-label',
  },
  5: {
    bgColor: 'twc-bg-color-turquoise-bg',
    textColor: 'twc-color-turquoise-fg',
    swatchColor: 'twc-bg-color-turquoise',
    tickColor: 'twc-color-surface-canvas',
  },
  6: {
    bgColor: 'twc-bg-color-mint-bg',
    textColor: 'twc-color-mint-fg',
    swatchColor: 'twc-bg-color-mint',
    tickColor: 'twc-color-mint-fg',
  },
  7: {
    bgColor: 'twc-bg-color-violet-bg',
    textColor: 'twc-color-violet-label',
    swatchColor: 'twc-bg-color-violet',
    tickColor: 'twc-color-violet-label',
  },
  8: {
    bgColor: 'twc-bg-color-indigo-bg',
    textColor: 'twc-color-indigo-fg',
    swatchColor: 'twc-bg-color-indigo',
    tickColor: 'twc-color-indigo-fg',
  },
  9: {
    bgColor: 'twc-bg-color-boysenberry-bg',
    textColor: 'twc-color-boysenberry-fg',
    swatchColor: 'twc-bg-color-boysenberry',
    tickColor: 'twc-color-surface-canvas',
  },
  10: {
    bgColor: 'twc-bg-color-purple-bg',
    textColor: 'twc-color-purple-label',
    swatchColor: 'twc-bg-color-purple',
    tickColor: 'twc-color-purple-label',
  },
  11: {
    bgColor: 'twc-bg-color-red-bg',
    textColor: 'twc-color-red-label',
    swatchColor: 'twc-bg-color-scarlet',
    tickColor: 'twc-color-red-label',
  },
  12: {
    bgColor: 'twc-bg-color-sunsetorange-bg',
    textColor: 'twc-color-sunsetorange-fg',
    swatchColor: 'twc-bg-color-sunset-orange',
    tickColor: 'twc-color-sunsetorange-fg',
  },
  13: {
    bgColor: 'twc-bg-color-coral-bg',
    textColor: 'twc-color-coral-fg',
    swatchColor: 'twc-bg-color-coral',
    tickColor: 'twc-color-coral-fg',
  },
  14: {
    bgColor: 'twc-bg-color-pink-bg',
    textColor: 'twc-color-pink-fg',
    swatchColor: 'twc-bg-color-pink',
    tickColor: 'twc-color-pink-fg',
  },
  15: {
    bgColor: 'twc-bg-color-darkorange-bg',
    textColor: 'twc-color-darkorange-fg',
    swatchColor: 'twc-bg-color-dark-orange',
    tickColor: 'twc-color-surface-canvas',
  },
  16: {
    bgColor: 'twc-bg-color-orange-bg',
    textColor: 'twc-color-orange-label',
    swatchColor: 'twc-bg-color-orange',
    tickColor: 'twc-color-surface-canvas',
  },
  17: {
    bgColor: 'twc-bg-color-yellow-bg',
    textColor: 'twc-color-yellow-label',
    swatchColor: 'twc-bg-color-amber',
    tickColor: 'twc-color-surface-canvas',
  },
  18: {
    bgColor: 'twc-bg-color-evergreen-bg',
    textColor: 'twc-color-evergreen-fg',
    swatchColor: 'twc-bg-color-evergreen',
    tickColor: 'twc-color-surface-canvas',
  },
  19: {
    bgColor: 'twc-bg-color-forestgreen-bg',
    textColor: 'twc-color-forestgreen-fg',
    swatchColor: 'twc-bg-color-forest-green',
    tickColor: 'twc-color-surface-canvas',
  },
  20: {
    bgColor: 'twc-bg-color-seagreen-bg',
    textColor: 'twc-color-seagreen-fg',
    swatchColor: 'twc-bg-color-sea-green',
    tickColor: 'twc-color-surface-canvas',
  },
  21: {
    bgColor: 'twc-bg-color-greylight-bg',
    textColor: 'twc-color-greylight-label',
    swatchColor: 'twc-bg-color-light-grey',
    tickColor: 'twc-color-primary-typeface',
  },
  22: {
    bgColor: 'twc-bg-color-darkgrey-bg',
    textColor: 'twc-color-darkgrey-fg',
    swatchColor: 'twc-bg-color-dark-grey',
    tickColor: 'twc-color-greydark-label',
  },
};

export const badgeSizes: SizeDefinition = {
  [BadgeSize.X_SMALL]: { size: 16, fontSize: 7 },
  [BadgeSize.SMALL]: { size: 24, fontSize: 9 },
  [BadgeSize.MEDIUM]: { size: 30, fontSize: 11 },
  [BadgeSize.LARGE]: { size: 36, fontSize: 14 },
};

export const defaultLocale = 'en-US';
